export class UserEnrollmentInEvent {
    isNotInvited: boolean = false;
    isJoined: boolean = false;
    isEventOwner: boolean = false;
}